import { c as _c } from "react/compiler-runtime";
import { useSearchPageMapData } from "@/hooks/search";
import { useDataFetchOrchestrator } from "@/hooks/use-data-fetch-orchestrator";
import { useUrlFilters } from "@/hooks/use-url-filters";
import { Bounds } from "@/types/map";
import { Filters } from "@/types/filters";
import { trackEvent } from "@/utils/analytics/track-event";
import { trackPropertySearch } from "@/utils/analytics/track-search";
import { transformFilters } from "@/utils/search/transform-filters";
import { useMap } from "@vis.gl/react-google-maps";
import { useCallback } from "react";
import { UseFormReturn } from "react-hook-form";
import { isDirtyFieldEmpty } from "./shared-utils";
interface UseFilterHandlersProps {
  form: UseFormReturn<Filters>;
  manualDirtyFields: React.MutableRefObject<Record<string, boolean>>;
  onApplyFilters?: (data: Partial<Filters>) => void;
}
export function useFilterHandlers(t0) {
  const $ = _c(14);
  const {
    form,
    manualDirtyFields,
    onApplyFilters
  } = t0;
  const {
    formState
  } = form;
  const mode = useSearchPageMapData(_temp);
  const fetchMapData = useSearchPageMapData(_temp2);
  const fetchNearByProjects = useSearchPageMapData(_temp3);
  let t1;
  if ($[0] !== fetchMapData || $[1] !== fetchNearByProjects || $[2] !== mode) {
    t1 = {
      mode,
      fetchMapData,
      fetchNearByProjects
    };
    $[0] = fetchMapData;
    $[1] = fetchNearByProjects;
    $[2] = mode;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    orchestrateFetch
  } = useDataFetchOrchestrator(t1);
  const {
    filters,
    setFilters
  } = useUrlFilters();
  const map = useMap();
  let t2;
  if ($[4] !== filters || $[5] !== formState.dirtyFields || $[6] !== manualDirtyFields || $[7] !== map || $[8] !== onApplyFilters || $[9] !== orchestrateFetch || $[10] !== setFilters) {
    t2 = data => {
      const filteredValues = {
        ...filters
      };
      (Object.keys(data) as Array<keyof Filters>).forEach(key => {
        const value = data[key];
        if (isDirtyFieldEmpty(key, value)) {
          delete filteredValues[key];
          return;
        }
        if (!formState.dirtyFields[key] && manualDirtyFields.current[key]) {
          console.log(`Manual Dirty: Field ${key} is marked as dirty manually`);
        }
        let isDirty = formState.dirtyFields[key] || manualDirtyFields.current[key] || key === "subType" && (formState.dirtyFields.propertyType || manualDirtyFields.current.propertyType);
        if (key === "budget" && typeof value === "object" && value !== null && "min" in value && "max" in value) {
          const budgetValue = value as {
            min: number;
            max: number;
          };
          if ((budgetValue.min ?? 0) > 0 || (budgetValue.max ?? 0) > 0) {
            isDirty = true;
          }
        }
        if (!isDirty) {
          return;
        }
        (filteredValues as Record<string, unknown>)[key] = value;
      });
      trackPropertySearch({
        filters: filteredValues
      });
      trackEvent({
        google: {
          event: "property_search"
        },
        matomo: {
          event: "filter-search",
          options: {
            category: "search"
          }
        }
      });
      const haveLocationsChanged = (() => {
        const currentLocations = filteredValues.locations || [];
        const previousLocations = filters.locations || [];
        if (currentLocations.length !== previousLocations.length) {
          return true;
        }
        const hasChanged = !currentLocations.every(currentLoc => previousLocations.some(prevLoc => prevLoc.id === currentLoc.id && prevLoc.name === currentLoc.name && prevLoc.type === currentLoc.type));
        return hasChanged;
      })();
      const mapBounds = map ? map.getBounds()?.toJSON() as Bounds : undefined;
      const mapZoom = map ? map.getZoom() : undefined;
      const {
        filtersForGraphQL,
        newFilters
      } = transformFilters({
        filters: filteredValues,
        mapBounds,
        mapZoom,
        haveLocationsChanged,
        from: "filters"
      });
      if (haveLocationsChanged) {
        if (newFilters.zoom) {
          map?.setZoom(newFilters.zoom);
        }
        if (newFilters.coordinates) {
          map?.panTo(newFilters.coordinates);
        }
      }
      setFilters(newFilters);
      orchestrateFetch({
        filters: newFilters,
        filtersForGraphQL,
        map
      });
      onApplyFilters?.(newFilters);
    };
    $[4] = filters;
    $[5] = formState.dirtyFields;
    $[6] = manualDirtyFields;
    $[7] = map;
    $[8] = onApplyFilters;
    $[9] = orchestrateFetch;
    $[10] = setFilters;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  const handleApplyFilters = t2;
  let t3;
  if ($[12] !== handleApplyFilters) {
    t3 = {
      handleApplyFilters
    };
    $[12] = handleApplyFilters;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}
function _temp3(state_1) {
  return state_1.fetchNearByProjects;
}
function _temp2(state_0) {
  return state_0.fetchMapData;
}
function _temp(state) {
  return state.mode;
}